import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Dropdown, Table } from "react-bootstrap";
import Spinner from "../components/Common/Spinner";
import Pagination from "../components/Common/Pagination";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import ReasonModal from "../components/Modal/ReasonModal";
import FullImage from "../components/Modal/FullImage";
import {
  approveMultiRequest,
  approveRejectRequest,
  getProfileImageVerificationRequests,
  getVerificationRequests,
} from "../../services/UserServices/UserService";
import dummmyImg from "../../images/profile/images.jpeg";
import { text } from "@fortawesome/fontawesome-svg-core";
import DisplayDeleteMessage from "../components/Modal/DisplayDeleteMessage";
import {
  genderFilterPost,
  isRejectedPost,
} from "../../store/actions/FilterActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function ReuploadProfileVerification() {
  const dispatch = useDispatch();
  const location = useLocation();
  const rejectedValue = useSelector(
    (state) => state.filter.filter.isRejectedValue
  );
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("reupload");
  const [gender, setGender] = useState(genderFilter);
  const [requests, setRequests] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const pageFromLocation =
    typeof location?.state?.page === "number" ? location.state.page : 0;
  const [currentPage, setCurrentPage] = useState(pageFromLocation);
  const [order, setOrder] = useState("mostRecent");
  const [isRejected, setIsRejected] = useState(rejectedValue);
  const [initialFetch, setInitialFetch] = useState(true);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("image");
  const imgBaseURl = "";
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);
  const chackbox = document.querySelectorAll(".custom-checkbox input");
  const motherChackBox = document.querySelector("#checkbox1_exam_all");
  const mainCheckBox = useRef();
  const didRunFilterEffectRef = useRef(false);
  const limit = 10;
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  //   console.log(selectedIds,"selectedIds")
  const chackboxFun = (type) => {
    // console.log(motherChackBox, "type");

    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };
  function handleSelectedId(data) {
    // console.log(id," id select")
    const oldData = selectedIds.find((item) => {
      return item == data;
    });
    if (oldData === undefined) {
      setSelectedIds([...selectedIds, data]);
    } else {
      let updatedArr = selectedIds.filter((item) => item !== data);
      console.log(updatedArr, " id removed");
      setSelectedIds([...updatedArr]);
    }
    console.log(oldData, "new id......");
  }

  function handleAllId() {
    const allId = requests?.map((item) => {
      return item;
    });
    if (mainCheckBox?.current?.checked) {
      setSelectedIds([...allId]);
    } else {
      setSelectedIds([]);
    }
  }
  const fetchRequests = async (page = currentPage) => {
    setLoader(true);
    try {
      const response = await getProfileImageVerificationRequests(
        page,
        limit,
        isRejected,
        // type,
        // status,
        gender,
        order
      );
      setRequests(response.data.data?.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
      if (page > 0 && (response.data.data?.users?.length || 0) === 0) {
        setCurrentPage(0);
      }
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };

  const onApprove = async (id) => {
    setLoader(true);
    try {
      const payload = { userId: id, type: type, status: "accepted" };
      const response = await approveRejectRequest(payload);
      fetchRequests();
      notifyTopRight(response.data?.message);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };
  const onMultiApprove = async (id) => {
    setLoader(true);
    try {
      // Extract only _id from selectedIds
      const userIds = selectedIds.map((item) => item._id);
      const payload = { userIds }; // Create payload with just _id array
      const response = await approveMultiRequest(payload);
      setSelectedIds([]);
      fetchRequests();
      notifyTopRight(response.data?.message);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchRequests(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (!didRunFilterEffectRef.current) {
      didRunFilterEffectRef.current = true;
      return;
    }
    if (currentPage !== 0) {
      setCurrentPage(0);
      return;
    }
    fetchRequests(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, gender, order, isRejected, type]);

  // Keep page in sync when navigating back/forward with location.state.page
  useEffect(() => {
    setCurrentPage(pageFromLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.key]);

  const handleImage = (text) => {
    console.log(text);
    setIsExpanded(true);
    setDeleteMessage(text);
  };

  return (
    <div>
      <Card>
        <Card.Header>
          {" "}
          <div></div>
          <div className="d-flex gap-2 flex-grow-1 align-items-end">
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Filter by Gender
              </label>

              <select
                className="form-control"
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                  dispatch(genderFilterPost(e.target.value));
                }}
              >
                <option value={"all"}>All</option>
                <option value={"male"}>Male</option>
                <option value={"female"}>Female</option>
                <option value={"member"}>Member</option>
                <option value={"pastMember"}>Past Member</option>
              </select>
            </div>
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Filter by Order
              </label>
              <select
                className="form-control"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
              >
                <option value={"all"}>All</option>
                <option value={"mostRecent"}>Most Recent</option>
              </select>
            </div>
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Delete Profile Re upload
              </label>
              <select
                className="form-control"
                value={isRejected}
                onChange={(e) => {
                  setIsRejected(e.target.value);
                  dispatch(isRejectedPost(e.target.value));
                }}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            {selectedIds?.length > 0 && (
              <div className="mb-2 mb-md-0 w-100 text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onMultiApprove()}
                >
                  Approve
                </button>
              </div>
            )}
          </div>
        </Card.Header>
        <Card.Body className="pb-0 pt-3">
          {loader ? (
            <Spinner />
          ) : (
            <Table responsive>
              <thead style={{ color: "black" }}>
                <tr>
                  {/* <th className="">
                    <div className="custom-control custom-checkbox-list checkbox-success check-lg mr-3">
                      <input
                        type="checkbox"
                        ref={mainCheckBox}
                        className="custom-control-input"
                        id="checkbox1_exam_all"
                        onChange={() => {
                          chackboxFun("all");
                          handleAllId();
                        }}
                        required=""
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="checkbox1_exam_all"
                      ></label>
                    </div>
                  </th> */}

                  <th>
                    <strong>NAME</strong>
                  </th>
                  <th>
                    <strong>Profile Pic</strong>
                  </th>
                  <th>
                    <strong>Gender</strong>
                  </th>
                  <th>
                    <strong>Delete Image Reason</strong>
                  </th>
                  {/* <th>
                    <strong>Hide</strong>
                  </th> */}
                  {/* <th>
                    <strong>STATUS</strong>
                  </th> */}
                  {/* <th>
                    <strong>ACTION</strong>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {requests?.map((item, i) => (
                  <tr key={i}>
                    {/* <td>
                      <div className="custom-control custom-checkbox-list checkbox-success check-lg mr-3">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={item._id}
                          checked={selectedIds.includes(item)}
                          onChange={() => {
                            chackboxFun();
                            handleSelectedId(item);
                          }}
                        />

                        <label
                          className="custom-control-label"
                          htmlFor={item._id}
                        ></label>
                      </div>
                    </td> */}

                    <td
                      onClick={() =>
                        navigate("/verification-user-details", {
                          state: {
                            data: item?._id,
                            selectedTab: "Re Upload Profile",
                            page: currentPage,
                          },
                        })
                      }
                      className="pointer"
                    >
                      {item?.name}
                    </td>
                    <td style={{display:"flex",justifyContent:"start",alignItems:"center",gap:"10px"}} className="pointer">
                    <div style={{width:"1px",border:item?.gender === "male" ? "2px solid blue" : "2px solid pink",padding:"0px",height:"80px"}}></div>
                      <img
                        src={
                          item?.images[0]?.url
                            ? imgBaseURl + item?.images[0]?.url
                            : dummmyImg
                        }
                        alt="img"
                        width={100}
                        height={80}
                        className="rounded"
                        onClick={() => {
                          setImageForView(imgBaseURl + item?.images[0]?.url);
                          setView(true);
                        }}
                      />
                    </td>
                    {/* <td className="pointer">
                      <img
                        src={imgBaseURl + item?.verificationImage?.url}
                        alt="img"
                        width={100}
                        height={80}
                        className="rounded"
                        onClick={() => {
                          setImageForView(
                            imgBaseURl + item?.verificationImage?.url
                          );
                          setView(true);
                        }}
                      />
                    </td> */}
                    <td>
                      {item?.gender &&
                        item?.gender?.charAt(0).toUpperCase() +
                          item?.gender?.slice(1)}
                    </td>
                    <td
                      className="pointer"
                      onClick={() =>
                        item?.reasonsToDeleteImages &&
                        handleImage(item?.reasonsToDeleteImages)
                      }
                    >
                      {item?.reasonsToDeleteImages && (
                        <span style={{ color: "#007bff" }}>Read Message</span>
                      )}
                    </td>
                    {/* <td>
                      <Badge bg="" className="badge-danger">
                        {item?.hideProfile && "Hide"}
                      </Badge>
                    </td> */}

                    {/* <td
                      onClick={() =>
                        navigate("/verification-user-details", {
                          state: { data: item?._id,selectedTab: "Re Upload" },
                        })
                      }
                      className="pointer"
                    >
                      {item?.gender === "male" ? (
                        item?.verificationImage?.isUploadAgain ? (
                          <Badge bg="" className="badge-warning">
                            Again Uploaded
                          </Badge>
                        ) : item?.verificationImage?.status === "pending" ? (
                          <Badge bg="" className="badge-warning">
                            Pending
                          </Badge>
                        ) : item?.verificationImage?.status === "accepted" ? (
                          <Badge bg="" className="badge-success">
                            Approved
                          </Badge>
                        ) : (
                          <Badge bg="" className="badge-danger">
                            Rejected
                          </Badge>
                        )
                      ) : item?.gender === "female" ? (
                        item?.verificationImage?.isUploadAgain ? (
                          <Badge bg="" className="badge-warning">
                            Again Uploaded
                          </Badge>
                        ) : item?.verificationImage?.adminAction ===
                          "pending" ? (
                          <Badge bg="" className="badge-warning">
                            Auto Approved
                          </Badge>
                        ) : item?.verificationImage?.adminAction ===
                          "accepted" ? (
                          <Badge bg="" className="badge-success">
                            Approved
                          </Badge>
                        ) : (
                          <Badge bg="" className="badge-danger">
                            Rejected
                          </Badge>
                        )
                      ) : (
                        ""
                      )}
                    </td> */}
                    {/* <td>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="info light"
                          className="light sharp btn btn-info i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                      </Dropdown>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {requests?.length === 0 && !loader && (
            <div className="justify-content-center d-flex my-5">
              Sorry, Data Not Found!
            </div>
          )}
          {requests?.length !== 0 && (
            <div className="card-footer clearfix">
              <div className="d-block d-sm-flex justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {currentPage * limit + 1} to{" "}
                  {listLength > (currentPage + 1) * limit
                    ? (currentPage + 1) * limit
                    : listLength}{" "}
                  of {listLength} entries
                </div>
                <Pagination
                  pageCount={pageCount}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                />
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
      {showRejectModal && (
        <ReasonModal
          show={showRejectModal}
          id={id}
          type={type}
          table={fetchRequests}
          onHide={() => setShowRejectModal(false)}
        />
      )}
      {isExpanded && (
        <DisplayDeleteMessage
          show={isExpanded}
          text={deleteMessage}
          onHide={() => setIsExpanded(false)}
        />
      )}
      {view && (
        <FullImage
          show={view}
          image={imageForView}
          onHide={() => setView(false)}
          imageType={"image"}
        />
      )}
    </div>
  );
}
